/**
 * Checkout — auto-capitalize name + city fields on blur.
 *
 * Baymard UX rec: user nie powinien martwić się o wielkość liter. Imię "jan" → "Jan",
 * miasto "nowy sącz" → "Nowy Sącz". Bezpieczne dla wszystkich polskich nazw — używa
 * `\p{L}` Unicode property escape żeby pokryć ą/ć/ę/ł/ń/ó/ś/ź/ż.
 *
 * Triggery:
 *  - `blur` — kiedy user opuszcza pole (NIE w trakcie pisania — irytujący caret jump)
 *  - po `change` w fieldzie miasta z auto-fill (postcode-lookup module odpala `change`)
 *
 * Edge cases:
 *  - "Bielsko-Biała", "Mińsk Mazowiecki" — separator (spacja/myślnik/apostrof) capitalizuje
 *    kolejne słowo. "O'Brien" → "O'Brien" (mało prawdopodobne w PL, ale safe).
 *  - "MARIA-ANNA" → "Maria-Anna" (toLowerCase najpierw, potem first-letter up).
 *  - Single character "a" → "A" — OK dla initial.
 *  - Empty value → no-op.
 *  - Camel-case ("McDonald", "O'Brien") → upraszcza do "Mcdonald" / "O'brien" — acceptable
 *    bo w PL ekstremalnie rzadkie i user może ręcznie poprawić jak nie pasuje.
 */

const TARGETS = [
    'billing_first_name',
    'billing_last_name',
    'shipping_first_name',
    'shipping_last_name',
    'billing_city',
    'shipping_city',
];

/**
 * "jan kowalski" → "Jan Kowalski"
 * "nowy sącz" → "Nowy Sącz"
 * "BIELSKO-BIAŁA" → "Bielsko-Biała"
 */
function capitalizeName(str) {
    if (!str) return str;
    /* `/u` flag + `\p{L}` = każda litera w Unicode (włącznie z ąćęłńóśźż).
     * Separator: początek string'a, whitespace, myślnik, apostrof. */
    return str.toLowerCase().replace(/(^|[\s\-'])(\p{L})/gu, (_, sep, ch) => sep + ch.toUpperCase());
}

function wire(input) {
    if (!input) return;
    input.addEventListener('blur', () => {
        const next = capitalizeName(input.value.trim());
        if (next === input.value) return;
        input.value = next;
        /* Trigger input + change żeby downstream listeners (shipping refresh, etc)
         * wiedzieli o normalizacji. Nie zmienia logiki bo wartości są semantycznie te same. */
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
    });
}

export function initCheckoutAutoCapitalize() {
    /* Skip jeśli nie jesteśmy na custom checkout. */
    if (!document.querySelector('form.checkout.hn-co')) return;
    TARGETS.forEach((id) => wire(document.getElementById(id)));
}
